var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"border rounded rounded-sm p-3 flex align-center bg-white shadow-sm"},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }